import React from "react";
import classes from "./Options.module.css";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { createMuiTheme } from '@material-ui/core/styles';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { connect } from "react-redux";
import { setOptions, updateQuestionOption } from "../../../../store/actions/questions.action";

class PictureOptions extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: ''
    }

  }

  componentWillReceiveProps(nextProps) {
    if (this.props.questionresponse !== nextProps.questionresponse) {
      this.setState({ value: nextProps.questionresponse.chosenOptionIds[0] });
    }

  }

  selectOption = async (event, value) => {
    this.setState({ value });
    let option = [value];
    this.props.updateQuestionOption(this.props.assesmentresponseid, this.props.question.id, option);

    this.props.setOptions(option);
  }


  render() {



    return (
      <MuiThemeProvider theme={theme}>
        <RadioGroup value={this.state.value} onChange={this.selectOption} style={{ overflow: "auto" }}>
          {this.props.options.map(choice =>
            <div className={classes.pictureoptiongrid}><div className={classes.option} ><FormControlLabel value={choice.id} control={<Radio />} /></div><img className={classes.imageoption} src={choice.images[0]} /></div>
          )
          }
        </RadioGroup>
      </MuiThemeProvider>

    );
  }
}

const theme = createMuiTheme({
  overrides: {
    // Style sheet name ⚛️
    MuiFormGroup: {
      // Name of the rule
      root: {
        display: 'grid',
        gridTemplateColumns: 'auto auto auto auto',
        justifyContent: 'start',
        gridColumnGap: 20,

      },
    },
  },
});

const mapStateToProps = state => {
  return {
    questionresponse: state.questionanswer.questionresponse,
    question: state.questionsReducer.question,
    assesmentresponseid: state.questionanswer.assessmentresponse.id,
  }
};

export default connect(mapStateToProps, { setOptions, updateQuestionOption })(
  PictureOptions
);
